import apiService from "./apiServices";

export const saveEmail = async(formData, token) => {
    try {
        const response = await apiService('/communication-email/save', 'POST', formData, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Saving email is failed. Please try again.');
        }
  }

  export const updateEmail = async (formData, token) => {
    try {

      const response = await apiService('/communication-email/update', 'PUT', formData, null, token);
      return response;
      } catch (error) {
        throw (error?.message || 'Updating email is failed. Please try again.');
      }
  }


  export const getAllEmail = async (token, page, size) => {
    try {

      const response = await apiService(`/communication-email/all?page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);

      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

  export const deleteEmailById = async (id, token) => {
    try {

      const response = await apiService(`/communication-email/delete/${id}`, 'DELETE', null, null, token);

      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

 export const searchCommunication = async (formData, token, page = 0, size = 5) => {
  try {
    const response = await apiService(
      `/communications/search?page=${page}&size=${size}`, // <-- pagination added
      'POST',
      formData,
      null,
      token
    );
    return response;
  } catch (error) {
    throw (error?.message || 'Searching communication failed. Please try again.');
  }
};

  export const saveSMS = async(formData, token) => {
    try {

        const response = await apiService('/communication-sms/save', 'POST', formData, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Saving sms is failed. Please try again.');
        }
  }

  export const updateSMS = async (formData, token) => {
    try {

      const response = await apiService('/communication-sms/update', 'PUT', formData, null, token);
      return response;
      } catch (error) {
        throw (error?.message || 'Updating sms is failed. Please try again.');
      }
  }

  export const getAllSmsTemplates = async (token) => {
    try {

      const response = await apiService('/sms-templates/all', 'GET', null, null, token);
    
      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

  export const getAllSMS = async (token, customer_id, page, size) => {
   
    try {
      const response = await apiService(`/sms/client-customer/${customer_id}?page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);

      return response;
    } catch (error) {
      throw (error?.message || 'sms service is failed. Please try again.');
    }
  }

  export const deleteSmsById = async (id, token) => {
    try {
      const response = await apiService(`/communication-sms/delete/${id}`, 'DELETE', null, null, token);

      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

  export const searchSMS = async(formData, token) => {
    try {
        const response = await apiService('/communication-sms/search', 'POST', formData, null, token);

        return response;
        } catch (error) {
          throw (error?.message || 'Searching sms is failed. Please try again.');
        }
  }


  export const savePhone = async(formData, token) => {
    try {

        const response = await apiService('/communication-phone/save', 'POST', formData, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Saving phone is failed. Please try again.');
        }
  }

  export const getAllPhones = async (token, page, size) => {
    try {

      const response = await apiService(`/communication-phone/phones/all?page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);
 
      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

  export const searchPhone = async(formData, token) => {
    try {

        const response = await apiService('/communication-phone/search', 'POST', formData, null, token);

        return response;
        } catch (error) {
          throw (error?.message || 'Searching sms is failed. Please try again.');
        }
  }


  export const sendMessage = async(formData, token) => {
    try {

        const response = await apiService('/sms/send', 'POST', formData, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Sending message is failed. Please try again.');
        }
  }

  export const getAllChatUserListService = async(token, page, size) => {
    try {

        const response = await apiService(`/sms/conversations?page=${page}&size=${size}`, 'GET', null, null, token);
    
        return response;
        } catch (error) {
          throw (error?.message || 'Sending message is failed. Please try again.');
        }
  }

  export const getSelectedUserChatService = async(token, phonenumber) => {
    try {

        const response = await apiService(`/sms/conversations/${phonenumber}/messages`, 'GET', null, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Sending message is failed. Please try again.');
        }
  }

  export const getUserCountService = async(token) => {
    try {

        const response = await apiService(`/sms/conversations/unread-count?page=0&size=50`, 'GET', null, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Sending message is failed. Please try again.');
        }
  }
  export const getUnreadCountService = async(token, unreadMessageIds) => {
    try {

        const response = await apiService(`/sms/messages/read`, 'PUT', unreadMessageIds, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Sending message is failed. Please try again.');
        }
  }
  export const getMessageSearchServices = async(token, messageQuery) => {
    try {

        const response = await apiService(`/sms/conversations/search?search=${messageQuery}`, 'GET', null, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Sending message is failed. Please try again.');
        }
  }
  export const getTotalMessageCountServices = async(token) => {
    try {

        const response = await apiService(`/sms/conversations/total-unread-count`, 'GET', null, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Sending message is failed. Please try again.');
        }
  }
  export const sendEmailServices = async(token, formData) => {
    console.log(formData, 'formData')
    try {

        const response = await apiService(`/communication-email/send-email`, 'POST', formData, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Sending message is failed. Please try again.');
        }
  }

 